import { render } from "./NewDesignPrompt.vue?vue&type=template&id=01ec52dd&scoped=true&ts=true"
import script from "./NewDesignPrompt.vue?vue&type=script&lang=ts"
export * from "./NewDesignPrompt.vue?vue&type=script&lang=ts"

import "./NewDesignPrompt.vue?vue&type=style&index=0&id=01ec52dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ec52dd"]])

export default __exports__